<template>
  <div class="dashboard-sidebar__inner py-3">
    <ul class="nav flex-column dashboard-nav">
      <li class="nav-item">
        <router-link exact to="/exam/begin" class="nav-link">
          <b-icon-pencil-fill></b-icon-pencil-fill> Начать тест
        </router-link>
      </li>
      <li class="nav-item">
        <router-link exact to="/dashboard" class="nav-link">
          <b-icon-house-fill></b-icon-house-fill> Панель управления
        </router-link>
      </li>
      <li class="nav-item">
        <router-link exact to="/dashboard/profile" class="nav-link">
          <b-icon-person-circle></b-icon-person-circle> Профиль
        </router-link>
      </li>
      <li class="nav-item">
        <router-link exact to="/error-report" class="nav-link">
          <b-icon-bug-fill></b-icon-bug-fill> Сообщить об ошибке
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  BIconHouseFill,
  BIconPersonCircle,
  BIconPencilFill,
  BIconBugFill
} from 'bootstrap-vue';

export default {
  components: {
    BIconHouseFill,
    BIconPersonCircle,
    BIconPencilFill,
    BIconBugFill
  },
  data() {
    return {
      visible: true
    };
  }
};
</script>
